<script setup lang="ts">
import type { FavoriteList } from '~/models/Favorites'
import type { BaseItem } from '~/models/Content/BaseItem'
import type { Task } from '~/models/AssignTask'
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import useAuthStore from '~/stores/auth'
import { PendoFeature } from '~/models/Pendo'
import { GradeType } from '~/models/GradeType'
import { isExamTask } from '~/composables/useAssignTags'
import FavoriteListCard from '~/components/favorites/cards/FavoriteListCard.vue'
import SearchCard from '~/components/cards/SearchCard.vue'
import ColorCard from '~/components/cards/ColorCard.vue'
import AssignedTaskCard from '~/components/cards/AssignedTaskCard.vue'

const { task } = defineProps<{ task: Task & { content?: BaseItem } }>()

const { selectedGradeType } = storeToRefs(useAuthStore())

const isSecondary = computed(() => selectedGradeType.value
  && [GradeType.Grade8To10, GradeType.GradeVgs].includes(selectedGradeType.value))
</script>

<template>
  <AssignedTaskCard
    v-if="isExamTask(task)"
    class="col-span-2 *:m-0"
    :task
  />
  <FavoriteListCard
    v-else-if="task.favoriteList"
    :class="{ 'col-span-2 row-span-2': isSecondary }"
    :list="task.favoriteList as FavoriteList"
    :data-pendo="PendoFeature.Share.Open"
    :task
  />
  <template v-else-if="task.content">
    <SearchCard
      v-if="isSecondary"
      class="col-span-2 row-span-1"
      :item="task.content"
      :data-pendo="PendoFeature.Share.Open"
      :task
    />
    <ColorCard
      v-else
      :resource="task.content"
      :data-pendo="PendoFeature.Share.Open"
      :task
    />
  </template>
</template>
